import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/credit'
  },
  {
    name: 'callbackResult',
    path: '/callbackResult',
    component: () => import('./view/callbackResult'),
    meta: {
      title: '小程序回调页'
    },
    props: route => ({
      msg: route.query.t,
    }),
  },
  {
    name: 'credit',
    path: '/credit',
    redirect: "/credit/home",
    component: () => import('./view/credit/Layout.vue'),
    props(route) {
      return {
        code: route.query.code,
        state: route.query.state,
      }
    },
    children: [
      {
        name: 'CreditNoPermission',
        path: 'noPermission',
        component: () => import('./view/noPermission/index.vue'),
        meta: {
          title: '权限不足'
        }
      },
      {
        name: 'CreditLogin',
        path: 'login',
        component: () => import('./view/login'),
        props(route) {
          return {
            source: route.query.source,
          }
        },
        meta: {
          title: '登录'
        }
      },
      {
        name: 'CreditWxCallback',
        path: 'wx-callback',
        component: () => import('./view/credit/WxCallback.vue'),
        meta: {
          title: '微信授权登录'
        }
      },
      {
        name: 'CreditBindAccount',
        path: 'bind-account',
        component: () => import('./view/credit/BindAccount.vue'),
        meta: {
          title: '绑定账号'
        }
      },
      {
        path: 'home',
        component: () => import('./view/credit/Home.vue'),
        name: 'CreditHome',
        meta: { title: '企业信息' }
      },
      {
        path: 'report',
        component: () => import('./view/credit/Report.vue'),
        name: 'Report',
        meta: { title: '企业简易报告' },
        props(route) {
          return {
            activeTab: parseInt(route.query.t),
            id: route.query.id,
          }
        },
      },
      {
        path: 'account',
        component: () => import('./view/credit/Account.vue'),
        name: 'CreditAccount',
        meta: { title: '个人中心' }
      },
      {
        path: 'invite',
        component: () => import('./view/invite/index.vue'),
        name: 'CreditInvite',
        meta: { title: '邀请好友' }
      },
      {
        name: 'CreditChangePassword',
        path: 'changePassword',
        props(route) {
          return {
            source: route.query.source,
          }
        },
        component: () => import('./view/changePassword'),
        meta: {
          title: '修改密码'
        }
      },
      {
        name: 'CreditEnterpriseManage',
        path: 'enterpriseManage',
        component: () => import('./view/enterpriseManage'),
        props: route => ({
          activeTab: route.query.t,
        }),
        meta: {
          title: '企业管理'
        }
      },
      {
        name: 'customerManage',
        path: 'customerManage',
        component: () => import('./view/customer'),
        meta: { title: '贷后管理' },
        props(route) {
          return {
            loanType: parseInt(route.query.loanType),
          }
        },
      },
      {
        name: 'CreditMessage',
        path: 'message',
        component: () => import('./view/message'),
        meta: { title: '消息管理' }
      },
    ]
  },
];

routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'history', routes });

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
